import { defineMessages } from 'react-intl';

export default defineMessages({
    view: {
        id: 'twia.quoteandbind.views.payments.view',
        defaultMessage: 'View'
    }
});